/**
 * Parking Lot Move Reasons
 * Used when a user moves a ticket to the parking lot via kebab menu.
 */
export const PARKING_LOT_REASONS = [
  { value: 'vehicle_completed', label: 'Vehicle Completed' },
  { value: 'waiting_for_parts', label: 'Waiting for Parts' },
  { value: 'customer_approval', label: 'Customer Approval Needed' },
  { value: 'deferred_work', label: 'Deferred Work' },
  { value: 'bay_needed', label: 'Bay Needed' },
  { value: 'other', label: 'Other' },
] as const;

export type ParkingLotReason = typeof PARKING_LOT_REASONS[number]['value'];
